import request from '@/utils/request'

// mp广告列表
export function mpAdvertList(params) {
  return request({
    url: `/ad_copy/mp_ads`,
    method: 'get',
    params
  })
}

// mp广告异步数据
export function mpAdvertListAsyncData(data) {
  return request({
    url: `/ad_copy/get_list_other`,
    method: 'post',
    data
  })
}

// mp广告主列表
export function mpAdvertiserList(params) {
  return request({
    url: `/ad_copy/account_list`,
    method: 'get',
    params
  })
}

// 复制mp广告
export function copyMpAdvert(data) {
  return request({
    url: `/ad_copy/copy_ad_mp`,
    method: 'post',
    data
  })
}

// 计划详情
export function campaignDetail(campaign_id, params) {
  return request({
    url: `/ad_copy/mp_ads/${campaign_id}`,
    method: 'get',
    params
  })
}

// mp复制列表
export function copyList(params = {}) {
  return request({
    url: `/ad_copy/mp_copy_list`,
    method: 'get',
    params
  })
}
